import { RouteRecordRaw } from "vue-router";
import { ROLES_AND_PERMISSION_ON_ROUTES } from "@/core/configs/rolesAndPermissionsMappingOnRoutes";

type RouteAccessKey =
  "APPROVAL_REQUESTS" | "MY_APPROVALS" | "ASSIGNED_APPROVALS";

const createApprovalRequestsRoutes = (
  namePrefix: string,
  accessKey: RouteAccessKey,
  includeDetail = false,
): Array<RouteRecordRaw> => {
  const access = ROLES_AND_PERMISSION_ON_ROUTES[accessKey];
  const meta = {
    roles: access.ROLES,
    permissions: access.PERMISSIONS,
  };

  const routes: Array<RouteRecordRaw> = [
    {
      path: "",
      name: `${namePrefix}List`,
      component: () => import("../views/ApprovalRequests.vue"),
      meta,
    },
  ];

  if (includeDetail) {
    routes.push({
      path: ":requestId",
      name: `${namePrefix}Detail`,
      component: () => import("../views/ApprovalRequestDetail.vue"),
      meta,
    });
  }

  return routes;
};

/** Legacy + detail host path */
const ApprovalRequestsRoutes = createApprovalRequestsRoutes(
  "ApprovalRequests",
  "APPROVAL_REQUESTS",
  true,
);

export const MyApprovalsRoutes = createApprovalRequestsRoutes(
  "MyApprovals",
  "MY_APPROVALS",
  true,
);
export const AssignedApprovalsRoutes = createApprovalRequestsRoutes(
  "AssignedApprovals",
  "ASSIGNED_APPROVALS",
  true,
);

export const ApprovalDelegationRoutes: Array<RouteRecordRaw> = [
  {
    path: "",
    name: "ApprovalDelegation",
    component: () => import("../views/ApprovalDelegation.vue"),
    meta: {
      roles: ROLES_AND_PERMISSION_ON_ROUTES.APPROVAL_DELEGATION.ROLES,
      permissions:
        ROLES_AND_PERMISSION_ON_ROUTES.APPROVAL_DELEGATION.PERMISSIONS,
    },
  },
];

export default ApprovalRequestsRoutes;
